import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { AppointmentType } from 'constants/appointmentType'
import { useAppointmentsService } from 'hooks/services'
import { useQuery } from 'react-query'
import { logFactory } from '../../util/logFactory'

interface UseResourceAppointmentTypesContext {
  appointmentTypes?: Record<DeliveryModel, AppointmentType[]>
  isError: boolean
  isLoading: boolean
}

const hookName = 'useResourceAppointmentTypes'
const log = logFactory(hookName)

const useResourceAppointmentTypes = (resourceId?: string): UseResourceAppointmentTypesContext => {
  const { getResourceAppointmentTypes, isReady } = useAppointmentsService()

  const fetchResourceAppointmentTypes = async (): Promise<Record<DeliveryModel, AppointmentType[]>> => {
    if (!resourceId) {
      return {
        [DeliveryModel.DIRECT_TO_CONSUMER]: [],
        [DeliveryModel.NETWORK]: [],
        [DeliveryModel.NETWORK_HOME_DELIVERY]: [],
        [DeliveryModel.TA_LIGHT]: [],
        [DeliveryModel.TA_ONSITE]: [],
        [DeliveryModel.TELEAUDIOLOGY]: [],
      }
    }

    log(`🗓️ Fetching resource's available appointment types...`, resourceId)

    const found = await getResourceAppointmentTypes(resourceId)

    log(`🗓️ Found resource's appointment types`, found)

    return found
  }

  const isQueryEnabled = Boolean(resourceId && isReady)

  const {
    data: appointmentTypes,
    isError,
    isLoading,
  } = useQuery([hookName, resourceId], fetchResourceAppointmentTypes, {
    enabled: isQueryEnabled,
  })

  return {
    appointmentTypes,
    isError,
    isLoading: (!isReady || isLoading) && !appointmentTypes,
  }
}

export { useResourceAppointmentTypes }
